import routes from 'js/core_pre_webpack/routes';
import fetchWithCsrf from 'js/utils/fetch_with_csrf';
import { TagType } from './types';

export const createUserTagging = (
  user_tag_type: string,
  user_tag_id: number,
  elapsed_time: number,
) => {
  const url = routes.api_v0_user_taggings_user_taggings_path({
    subdomain_param: 'api',
  });
  const data = JSON.stringify({
    user_tag_type,
    user_tag_id,
    elapsed_time,
  });
  return fetchWithCsrf(url, {
    method: 'POST',
    body: data,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const createCustomUserTagging = (
  user_tag_type: string,
  custom_tag_text: string,
) => {
  const url = routes.api_v0_user_taggings_user_taggings_path({
    subdomain_param: 'api',
  });
  const data = JSON.stringify({
    user_tag_type,
    custom_tag_text,
  });
  return fetchWithCsrf(url, {
    method: 'POST',
    body: data,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const updateUserTagging = (
  tagging_id: number,
  user_tag_id: number,
  elapsed_time: number,
  custom_tag_text?: string,
) => {
  const url = routes.api_v0_user_taggings_user_tagging_path({
    subdomain_param: 'api',
    id: tagging_id,
  });
  const data = JSON.stringify({
    user_tag_id,
    elapsed_time,
    custom_tag_text,
  });
  fetchWithCsrf(url, {
    method: 'PUT',
    body: data,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const deleteUserTagging = (tagging_id: number | undefined) => {
  if (tagging_id === undefined || tagging_id === -1) return;

  const url = routes.api_v0_user_taggings_user_tagging_path({
    subdomain_param: 'api',
    id: tagging_id,
  });
  const data = JSON.stringify({
    tagging_id: tagging_id,
  });
  fetchWithCsrf(url, {
    method: 'DELETE',
    body: data,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const createFreeformUserTagging = (
  user_tag_type: TagType,
  freeform_tags: string[],
  source: string,
) => {
  const url = routes.api_v0_user_taggings_user_taggings_path({
    subdomain_param: 'api',
  });
  const data = JSON.stringify({
    user_tag_type,
    freeform_tags,
    source,
  });
  return fetchWithCsrf(url, {
    method: 'POST',
    body: data,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const createRIUserTagging = (
  user_tag_type: 'UserTaggings::UserTopic',
  ris: { name: string; id: number }[],
  source: string,
) => {
  const url = routes.topics_api_v0_user_taggings_user_taggings_path({
    subdomain_param: 'api',
  });
  const data = JSON.stringify({
    user_tag_type,
    ris,
    source,
  });
  return fetchWithCsrf(url, {
    method: 'POST',
    body: data,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};
